import React, { useState, useEffect, useMemo } from 'react';
import Dropdown from '../../lib/dropDown';
import { Link, useLocation } from 'react-router-dom';
import { checkPermissions } from "../../Services/User/User";
import { toast } from 'react-toastify';
import { getTvApkProjectAll } from "../../Services/TvApksService/TvApkService";

const SideNav = () => {
  const location = useLocation();
  const [changeDropDown, setChangeDropDown] = useState(false);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const fetchTvApkProjects = async () => {
      try {
        const response = await getTvApkProjectAll();
        if (response?.status) {
          setProjects(response.data || []);
        }
      } catch (error) {
        toast.error("Error fetching TV APK projects");
      }
    };

    fetchTvApkProjects();
  }, []);

  const menu = useMemo(() => [
    {
      url: '/games/',
      title: 'Games',
      className: 'bi-controller',
      collapsNav: 'Games-Nav',
      permission_key: 'games_navigation',
      items: [
        { itemUrl: '/games/gamelist', permission_key: 'games_list_page', link: '/games/gamelist', text: 'Game List' },
        { itemUrl: '/games/offlineGames', permission_key: 'offline_game_page', link: '/games/offlineGames', text: 'Offline Games' },
        { itemUrl: '/games/subject', permission_key: 'subject_page', link: '/games/subject', text: 'Subject' },
        { itemUrl: '/games/categories', permission_key: 'category_page', link: '/games/categories', text: 'Categories' },
        { itemUrl: '/games/marketingBanners', permission_key: 'marketing_banners_page', link: '/games/marketingBanners', text: 'Marketing Banners' },
        { itemUrl: '/games/createQuiz', link: '/games/createQuiz', text: 'Create Quiz' },
      ],
    },
    {
      url: '/userAndSubscribers/',
      title: 'Users & Admin',
      collapsNav: 'Uas-Nav',
      className: 'bi-reception-4',
      permission_key: 'users_navigation',
      items: [
        { itemUrl: '/userAndSubscribers/usersList', permission_key: 'users_list_page', link: '/userAndSubscribers/usersList', text: 'Online Users list' },
        // { itemUrl: '/userAndSubscribers/offlineUsersList', permission_key: 'users_list_page', link: '/userAndSubscribers/offlineUsersList', text: 'TV APK Users list' },
        { itemUrl: '/userAndSubscribers/systemUsers', permission_key: 'system_users_page', link: '/userAndSubscribers/systemUsers', text: 'System Users' },
      ],
    },
    {
      url: '/userAndSubscribers/project/',
      title: 'TV APK User Manage',
      collapsNav: 'TvApkManage-Nav',
      className: 'bi-tv',
      permission_key: 'users_navigation',
      items: [
        ...projects
          .filter((project) => Array.isArray(project.tvApks) && project.tvApks.length > 0)
          .map(project => ({
            itemUrl: `/userAndSubscribers/project/${project.id}`,
            permission_key: 'users_list_page',
            link: `/userAndSubscribers/project/${project.id}`,
            text: project.name
          }))
      ]
    },
    {
      url: '/developer/',
      title: 'Developer',
      collapsNav: 'Developer-Nav',
      className: 'bi-code-slash',
      permission_key: 'developer_navigation',
      items: [
        { itemUrl: '/developer/database', permission_key: 'database_page', link: '/developer/database', text: 'Database' },
        { itemUrl: '/developer/logs', permission_key: 'log_page', link: '/developer/logs', text: 'Logs' },
        { itemUrl: '/developer/s3', permission_key: 's3_access_page', link: '/developer/s3', text: 'S3 file explorer' },
      ],
    },
    {
      url: '/masters/',
      title: 'Masters',
      className: 'bi-controller',
      collapsNav: 'Masters-Nav',
      permission_key: 'games_navigation',
      items: [
        { itemUrl: '/masters/assets', permission_key: 'games_list_page', link: '/masters/assets', text: 'Assets' },
        { itemUrl: '/masters/tvApkProjects', permission_key: 'games_list_page', link: '/masters/tvApkProjects', text: "TV APK Projects" },
        { itemUrl: '/masters/games', permission_key: 'games_list_page', link: '/masters/games', text: 'Games' },
      ],
    },
    {
      url: '/settings/',
      title: 'Settings',
      collapsNav: 'Settings-Nav',
      className: 'bi-gear',
      permission_key: 'settings_navigation',
      items: [
        { itemUrl: '/settings/systemSettings', permission_key: 'system_settings_page', link: '/settings/systemSettings', text: 'System Settings' },
        { itemUrl: '/settings/online-content', permission_key: 'system_settings_page', link: '/settings/online-content', text: 'Online FAQ & Support' },
        { itemUrl: '/settings/accessControl', permission_key: 'access_control_page', link: '/settings/accessControl', text: 'Access Control' },
        { itemUrl: '/settings/roles', permission_key: 'role_page', link: '/settings/roles', text: 'Roles' },
      ],
    },
  ], [projects]);

  const normalizePath = (path) => path.replace(/\/+$/, '').split('/').filter(Boolean);

  const isPathActive = (itemUrl) => {
    const currentSegments = normalizePath(location.pathname);
    const itemSegments = normalizePath(itemUrl);

    if (currentSegments.length < itemSegments.length) {
      return false;
    }

    return itemSegments.every((segment, index) => currentSegments[index] === segment);
  };

  const dropdowns = useMemo(() => menu.map((data) => {
    const items = data.items.map((item) => ({
      ...item,
      itemIsActive: isPathActive(item.itemUrl) ? 'T' : false,
    }));

    return {
      ...data,
      isActive: items.some((item) => item.itemIsActive === 'T'),
      items,
    };
  }), [menu, location.pathname, changeDropDown]);

  const menuRerander = () => {
    setChangeDropDown((prev) => !prev);
  };

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        <li className="nav-item">
          <Link to="/home" className="nav-link indexnav">
            <i className="bi bi-grid"></i>
            <span>Dashboard</span>
          </Link>
        </li>
        {dropdowns.map((dropdown, index) => {
          return checkPermissions(dropdown.permission_key) && (
            <Dropdown
              dropdownclassName={dropdown.className}
              key={index}
              dropdownTitle={dropdown.title}
              items={dropdown.items}
              collapsNav={dropdown.collapsNav}
              isActive={dropdown.isActive}
              menuRerander={menuRerander}
            />
          );
        })}
      </ul>
    </aside>
  );
};

export default SideNav;